/**
 * Shared tone-from-threshold utility.
 * Eliminates nested ternary anti-pattern across dashboard widgets.
 */

export type Tone = "ok" | "warn" | "risk";

/**
 * Returns a semantic tone based on a numeric value against high/low thresholds.
 * Defaults: >= 85 → "ok", >= 70 → "warn", else → "risk".
 */
export function toneFromThresholds(value: number, high = 85, low = 70): Tone {
  if (value >= high) return "ok";
  if (value >= low) return "warn";
  return "risk";
}

/**
 * Returns a CSS color variable for the given tone.
 */
export function colorFromTone(tone: Tone): string {
  if (tone === "ok") return "var(--ok)";
  if (tone === "warn") return "var(--warn)";
  return "var(--risk)";
}

/**
 * Returns a CSS color variable directly from a value using thresholds.
 * Defaults: >= 85 → ok, >= 70 → warn, else → risk.
 */
export function colorFromThresholds(
  value: number,
  high = 85,
  low = 70,
): string {
  return colorFromTone(toneFromThresholds(value, high, low));
}
